// extracted by mini-css-extract-plugin
export var lg = "_47-4";
export var md = "_47-3";
export var sm = "_47-2";
export var xs = "_47-1";
export var xxs = "_47-0";